import type { ComponentType } from 'react'

/**
 * Per-world UI slots: components a world app may supply in place of the shared
 * default. The world-config package stays React-free, so these are registered
 * from the app's `main.tsx` (before the router renders) rather than declared in
 * `WorldConfig`. A world that registers nothing gets the shared default, so
 * adding a slot never changes another world's site.
 *
 * Each slot is a lazy loader, so a world's custom page ships as its own chunk.
 */
export interface WorldSlots {
  /** The landing page at `/:locale`. Default: `features/home/HomePage`. */
  homePage?: () => Promise<{ default: ComponentType }>
}

let slots: WorldSlots = {}

export function setWorldSlots(next: WorldSlots): void {
  slots = { ...next }
}

export function getWorldSlots(): Readonly<WorldSlots> {
  return slots
}
